<div class="flex flex-col wrapper white-fg m--24 p-24">
  <div dir="rtl">
    <mat-icon svgIcon="close" [mat-dialog-close]="null" class="cursor-pointer"></mat-icon>
  </div>

  <ng-container *ngIf="!unlockRequestSent; else showThankYouMessage">
    <div class="flex flex-col content-wrapper">
      <div class="flex items-center mat-headline-3 mb-40">{{'UPGRADE_PLAN.TO_CONTINUE' | transloco}}</div>

      <div class="flex flex-row gap-x-6">
        <mat-card class="flex flex-col plan-card trial-sandbox pt-50 pr-34 pb-50 pl-34">
          <div class="mat-headline-6 mb-8 fw-700">{{'UPGRADE_PLAN.TRIAL_SANDBOX' | transloco}}</div>

          <div class="mat-subtitle-2 fw-400 for-evaluation mb-4">{{'UPGRADE_PLAN.FOR_EVALUATION' | transloco}}</div>

          <mat-card-content class="flex flex-col">
            <div *ngFor="let benefit of sandboxBenefits" class="flex flex-row mat-subtitle-2 fw-400 pt-14 pb-14 line-height"  [ngClass]="{'disabled': benefit.includes('CREATE_TRIAL_SERVICE')}">
              <div class="flex items-center check-icon mr-10 mt-4">
                <mat-icon [svgIcon]="benefit.includes('CREATE_TRIAL_SERVICE')? 'close' : 'done'" class="h-10 w-10"></mat-icon>
              </div>
              <div class="flex flex-row">
                {{'UPGRADE_PLAN.' + benefit | transloco}}
              </div>
            </div>
          </mat-card-content>

          <span class="flex-auto"></span>

          <mat-card-actions class="flex items-center mt-50 pl-50 pr-50">
            <button class="flex items-center transparent" (click)="closeDialog('UPGRADE_PLAN.CREATE_TRIAL_SANDBOX')" [disabled]="data?.displayStartFreeTrialButton || data?.disableCreateSandbox || !hasCreateSandboxPermission">
							<mat-icon svgIcon="add" class="icon-sm mr-10"></mat-icon>
							<span class="fw-700">{{'UPGRADE_PLAN.CREATE_TRIAL_SANDBOX' | transloco}}</span>
            </button>
          </mat-card-actions>

        </mat-card>

        <mat-card class="flex flex-col plan-card enterprise-card pb-50 pr-34">
					<button class="primary upgrade-to w-102 h-30 pt-2 pr-16 pb-2 pl-16 fs-12">{{'UPGRADE_PLAN.UPGRADE_TO' | transloco}}</button>
          <div class="mat-headline-6 mt-4 mb-16 enterprise">{{'UPGRADE_PLAN.ENTERPRISE' | transloco}}</div>

          <div class="mat-subtitle-2 fw-400 for-live-service mb-30">{{'UPGRADE_PLAN.FOR_LIVE_SERVICE' | transloco}}</div>

          <mat-card-content class="flex flex-col">
            <div *ngFor="let benefit of enterpriseCardBenefits" class="flex flex-row mat-subtitle-2 fw-400 pt-14 pb-14 pl-14 line-height" >
              <div class="flex items-center check-icon mr-10 mt-2">
                <mat-icon svgIcon="done" class="h-10 w-10"></mat-icon>
              </div>
              <div class="flex flex-row">
                {{'UPGRADE_PLAN.' + benefit | transloco}}
              </div>
            </div>
          </mat-card-content>

          <span class="flex-auto"></span>

          <mat-card-actions class="flex items-center mt-50 pl-90 pr-90">
            <button class="flex items-center accent" (click)="closeDialog('UPGRADE_PLAN.CONTACT_SALES')">							
							<span class="fw-700">{{'UPGRADE_PLAN.CONTACT_SALES' | transloco}}</span>
              <mat-icon svgIcon="arrow_forward" class="icon-sm ml-10"></mat-icon>
            </button>
          </mat-card-actions>

        </mat-card>
      </div>
    </div>
  </ng-container>

  <ng-template #showThankYouMessage>
    <div @thankYouMessage class="flex flex-col items-center min-width-lg">
      <img class="upgrade-image" src="/assets/images/Thank you.png"/>
      <div class="mat-headline-3 mb-40 thank-you-message text-align-center">
        {{'UPGRADE_PLAN.THANK_YOU_FOR_CHOOSING' | transloco}}
      </div>
      <div class="mb-40 mat-headline-6 on-your-way-message text-align-center">{{'UPGRADE_PLAN.ON_YOUR_WAY' | transloco}}</div>
      <button class="accent ok-button" [mat-dialog-close]="null">{{'OK'}}</button>
    </div>
  </ng-template>
</div>
